import { array, object, string } from 'zod';

export const ANSWER_TEXT_REQUIRED_MESSAGE =
  'Subjective Answer text is required';
export const QuizSubjectiveDataSchema = object({
  answerList: array(
    object({
      key: string(),
      text: string().min(1, ANSWER_TEXT_REQUIRED_MESSAGE),
    }),
  ),
});
